jQuery(document).ready(function($){

  let state = "close";

  console.log('# HAMBURGER #')

  $('.rolex-header .mobile-menu-button').on('click', function() {
    // $('.hamburger-menu').toggleClass('animate');

    if (state === "close") {
      // $('.mobile-navigation').css("transform", "translate(0, 84px)");
	  var toph = $('.rolex-header').outerHeight();
      $('.rolex-header .mobile-navigation').css("opacity", "1");
	  $('.rolex-header .mobile-navigation').css("top", toph);
	  $('.rolex-header .mobile-navigation').css("visibility", "visible");
	  $('.rolex-header .mobile-navigation').css("display", "block");
      $('.arrow').css("transform", "rotate(-90deg)");
      state = "open";
    } else {
      // $('.mobile-navigation').css("transform", "translate(0, -1000px)");
      $('.rolex-header .mobile-navigation').css("opacity", "0");
      $('.arrow').css("transform", "rotate(90deg)");
	  $('.rolex-header .mobile-navigation').css("visibility", "hidden");
	  $('.rolex-header .mobile-navigation').css("display", "none");
      state = "close";
    }
  })

  console.log('# scroll-top #');

  $("a[href='#top']").click(function() {
    $("html, body").animate({ scrollTop: 0 }, "slow");
    return false;
  });

  console.log('# load-slick #');
  
  $('.carousel-slider').slick({
    dots: true,
    arrows: true,
    autoplay: false,
    infinite: true,
    draggable: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow:"<div class='slick-prev'></div>",
    nextArrow:"<div class='slick-next'></div>",
    appendDots: $('.carousel-buttons'),
    responsive: [
      {
        breakpoint: 1069,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false
        }
      }
    ]
  });

  $('.keep-exploring').slick({
    dots: true,
    arrows: true,
    autoplay: false,
    infinite: true,
    draggable: true,
    slidesToShow: 4,
    slidesToScroll: 4,
    prevArrow:"<div class='slick-prev'></div>",
    nextArrow:"<div class='slick-next'></div>",
    appendDots: $('.nav-buttons'),
    responsive: [
      {
        breakpoint: 1069,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          arrows: true
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          arrows: false
        }
      }
    ]
  });

  $('.product-gallery').slick({
    dots: true,
    appendDots: $('.product-gallery-navdots'),
    arrows: true,
    autoplay: false,
    infinite: true,
    draggable: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    asNavFor: '.thumbnail-container',
    prevArrow:"<div class='slick-prev'></div>",
    nextArrow:"<div class='slick-next'></div>",
    responsive: [
      {
        breakpoint: 1069,
        settings: {
          slidesToShow: 1
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          dots: true,
          appendDots: $('.product-gallery-navdots'),
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          dots: true,
          appendDots: $('.product-gallery-navdots'),
        }
      }
    ]
  });
  
  $('.cpo.thumbnail-container').slick({
    slidesToShow: 5,
    slidesToScroll: 5,
    asNavFor: '.product-gallery',
    dots: false,
    arrows: false,
    infinite: false,
    centerMode: false,
    focusOnSelect: true,
    variableWidth: false
  });

  $('.thumbnail-container').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    asNavFor: '.product-gallery',
    dots: false,
    arrows: false,
    infinite: true,
    centerMode: false,
    focusOnSelect: true,
    variableWidth: true
  });

  $('.suggested-products').slick({
    dots: true,
    arrows: true,
    autoplay: false,
    infinite: true,
    draggable: true,
    slidesToShow: 3,
    slidesToScroll: 3,
    prevArrow:"<div class='slick-prev'></div>",
    nextArrow:"<div class='slick-next'></div>",
    appendDots: $('.nav-buttons'),
    responsive: [
      {
        breakpoint: 1069,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          arrows: true
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          arrows: false
        }
      }
    ]
  });


  console.log('# FILTERS #')

  $('.rolex-filters-btn').on('click', function() {
    $('.sidebar').show();
    $('.sidebar').css('display', 'block');
  })

  $('.filters-close-btn').on('click', function() {
    $('.sidebar').hide();
    $('.sidebar').css('display', 'none');
  })

  $('.view-results-btn').on('click', function() {
    $('.sidebar').hide();
    $('.sidebar').css('display', 'none');
  })

  $('.rolex-opening-times').click(function(){
    $(this).toggleClass('open');
    $('.rolex-opening-hours').slideToggle();
  });


  // ADOBE EVENT TRIGGERS

  $('a.adobe-call-tag').on('click', function() {
    console.log('# ADOBE CALL TAG #')
    _satellite.track('contactCall');
  })

  $('a.adobe-findastore-tag').on('click', function() {
    console.log('# ADOBE FIND-A-STORE TAG #')
    _satellite.track('findStore');
  })

  $('a.adobe-directions-tag').on('click', function() {
    console.log('# ADOBE DIRECTIONS TAG #')
    _satellite.track('getDirections');
  })

  // NOTE: tracking event moved to Thank You landing page for Rolex Contact form
  // $('#gform_submit_button_29').on('click', function() {
  //   console.log('# GRAVITY FORMS TRACKING HIT #')
  //   _satellite.track('contactForm');
  // })

  // AUTO-POPULATE HIDDEN FIELD ON GRAVITY FORM WITH MODEL NUMBER
  console.log('# GRABBER #')
  var productGrab = $('#product-grab');
  console.log(productGrab);
  $('#input_29_15').value = productGrab;

});